/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdFinancialDataMutationRequest,
  PutApiV1PersonIdFinancialDataMutationResponse,
  PutApiV1PersonIdFinancialDataPathParams,
  PutApiV1PersonIdFinancialData400,
  PutApiV1PersonIdFinancialData401,
  PutApiV1PersonIdFinancialData404,
  PutApiV1PersonIdFinancialData500,
} from "../../types/personFinancialController/PutApiV1PersonIdFinancialData.ts";

function getPutApiV1PersonIdFinancialDataUrl(
  id: PutApiV1PersonIdFinancialDataPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/person/${id}/financial-data` as const,
  };
  return res;
}

/**
 * @description Atualiza a aba Financial. Cria o PersonFinancial caso ainda não exista. Todos os campos informados sobrescrevem os atuais. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados financeiros (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/financial-data}
 */
export async function putApiV1PersonIdFinancialData(
  id: PutApiV1PersonIdFinancialDataPathParams["id"],
  data?: PutApiV1PersonIdFinancialDataMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1PersonIdFinancialDataMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdFinancialDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdFinancialData400
      | PutApiV1PersonIdFinancialData401
      | PutApiV1PersonIdFinancialData404
      | PutApiV1PersonIdFinancialData500
    >,
    PutApiV1PersonIdFinancialDataMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdFinancialDataUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
